module.exports = __webpack_public_path__ + "media/images/banner-b951b7b479a67ebd6fd6058681c36bc3.jpg";